<template>
  <StdPageForm>
    <vh-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
      <vh-form-item label="标题" prop="title">
        <vh-input
          v-model="ruleForm.title"
          placeholder="请输入标题"
          maxlength="100"
          show-word-limit
          style="width: 560px"
        ></vh-input>
      </vh-form-item>
      <vh-form-item label="参与条件" prop="watch_minute">
        <vh-radio-group v-model="ruleForm.active_rule_cardinal">
          <vh-radio :label="1" v-if="type != 2" class="lh-20">无条件（全体参会者）</vh-radio>
          <vh-radio :label="2" class="lh-20">
            观看
            <vh-select v-model="ruleForm.watch_minute" style="display: inline-block; width: 90px">
              <vh-option
                v-for="(num, index) in new Array(16).fill().map((_, i) => (i + 1) * 5)"
                :key="index"
                :label="num + '分钟'"
                :value="num"
              ></vh-option>
            </vh-select>
            可领红包
          </vh-radio>
        </vh-radio-group>
      </vh-form-item>
      <vh-form-item label="发放模式" prop="grant_type">
        <vh-radio-group v-model="ruleForm.grant_type" @change="handleGrantTypeChange">
          <vh-radio :label="1" class="lh-20">固定金额</vh-radio>
          <vh-radio :label="2" class="lh-20">随机金额</vh-radio>
        </vh-radio-group>
      </vh-form-item>
      <vh-form-item label="单个金额" v-if="ruleForm.grant_type == 1" prop="each_amount">
        <p class="text-mute">请保证您的微信商户号金额额度充足，否则将会影响观众领取</p>
        <vh-input
          style="width: 120px"
          placeholder="0.00"
          type="number"
          v-model="ruleForm.each_amount"
        >
          <template slot="append">元</template>
        </vh-input>
      </vh-form-item>
      <vh-form-item label="总金额" v-else-if="ruleForm.grant_type == 2" prop="total_amount">
        <p class="text-mute">
          {{ ruleForm.total_amount || '0.00' }}
          元（请结合您的微信商户号金额额度进行设置，不可低于此额度，否则将会影响观众领取）
        </p>
        <vh-input
          style="width: 120px"
          type="number"
          placeholder="0.00"
          v-model="ruleForm.total_amount"
        >
          <template slot="append">元</template>
        </vh-input>
      </vh-form-item>
      <vh-form-item label="红包个数" prop="red_packet_num">
        <vh-input
          style="width: 160px"
          type="number"
          placeholder="最多5000个"
          v-model.number="ruleForm.red_packet_num"
        >
          <template slot="append">个</template>
        </vh-input>
      </vh-form-item>
      <!-- <vh-form-item
        label="回放领取"
        prop="record_support"
        v-if="ruleForm.active_rule_cardinal == 2 && type != 2"
      >
        <vh-radio-group v-model="ruleForm.record_support">
          <vh-radio :label="1" class="lh-20">否</vh-radio>
          <vh-radio :label="2" class="lh-20">是</vh-radio>
        </vh-radio-group>
      </vh-form-item> -->
      <vh-form-item>
        <p class="text-notice">
          提示：
          <br />
          1.所有发放的金额均在您的微信商户号中，不会进入到直播的账号；观众提现到个人微信零钱中
          <br />
          2.使用「现金红包」能力，需要将已认证的服务号（服务号为企业性质）授权给到平台
          <a href="/v3/setting/officialAccAuth" target="_blank" class="link">前往授权 ></a>
          <br />
          3.需要开通微信商户号（微信商户号与授权给平台的服务号是绑定关系），需要开通微信零钱转账功能
          <a href="https://saas-doc.vhall.com/opendocs/show/1772" target="_blank" class="link">
            查看详细说明 >
          </a>
          <br />
          4.当红包在回放中领取时，红包发送完之后自动停止，此时观众端依旧展示红包入口
          <br />
          5.红包仅支持微信环境领取，请引导观众使用微信观看直播
        </p>
      </vh-form-item>
      <vh-form-item>
        <vh-button round type="primary" @click="submitForm('ruleForm')">保存</vh-button>
      </vh-form-item>
    </vh-form>
  </StdPageForm>
</template>

<script>
  import { getRedPacketInfo, createRedPacket, editRedPacket } from '../common/api';
  import { throttle } from 'lodash';
  export default {
    props: {
      webinarId: {},
      redPacketId: {},
      type: {}
    },
    data() {
      return {
        ruleForm: {
          webinar_id: this.webinarId,
          id: this.redPacketId || undefined,
          title: '', // 标题
          active_rule_cardinal: this.type != 2 ? 1 : 2, // 参与条件 1 无条件、 2 根据观看时长参与
          watch_minute: 45, // 观看分钟数（参与条件）
          grant_type: 1, // 发放模式 1 固定金额、 2随机金额
          each_amount: undefined, // 单个金额 单位 分
          total_amount: undefined, // 总金额 单位 分
          red_packet_num: undefined, //红包个数
          // record_support: this.type != 2 ? 1 : undefined, //回放领取方式 1 不支持 2 支持
          type: this.type || 1 //  1 直播 2 回放
        },
        custom_minute: '',
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' },
            { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
          ],
          each_amount: [
            { required: true, message: '请输入单个金额', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (Number(value) < 0.1) {
                  callback(new Error('金额不能小于0.1元'));
                } else if (Number(value) > 200) {
                  callback(new Error('金额不能大于200元'));
                } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                  callback(new Error('小数点后不能超两位'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          total_amount: [
            { required: true, message: '请输入总计额', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (Number(value) < 0.1) {
                  callback(new Error('金额不能小于0.1元'));
                } else if (Number(value) > 200) {
                  callback(new Error('金额不能大于200元'));
                } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                  callback(new Error('小数点后不能超两位'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ],
          red_packet_num: [
            { required: true, message: '请输入红包个数', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!/^[1-9]\d*$/.test(value)) {
                  callback(new Error('请输入正整数'));
                } else if (Number(value) > 5000) {
                  callback(new Error('红包个数不能大于5000个'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        }
      };
    },
    methods: {
      handleGrantTypeChange() {
        if (this.ruleForm.grant_type == 1) {
          this.ruleForm.total_amount = undefined;
        } else {
          this.ruleForm.each_amount = undefined;
        }
      },
      liveModeChange(index) {
        this.ruleForm.liveMode = index;
      },
      handleNodelaySelect() {
        this.ruleForm.noDelay = !this.ruleForm.noDelay;
      },
      submitForm: throttle(
        function (formName) {
          this.$refs[formName].validate(valid => {
            if (valid) {
              const data = {
                ...this.ruleForm
              };
              if (this.ruleForm.each_amount) {
                data.each_amount = (this.ruleForm.each_amount * 100).toFixed(0);
              }
              if (this.ruleForm.total_amount) {
                data.total_amount = (this.ruleForm.total_amount * 100).toFixed(0);
              }

              const fetch = this.redPacketId ? editRedPacket : createRedPacket;
              fetch(data).then(res => {
                if (res.code === 200) {
                  this.$emit('save');
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }
              });
            }
          });
        },
        3000,
        { trailing: false }
      ),
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getRedPacketInfo() {
        getRedPacketInfo({ id: this.redPacketId }).then(res => {
          if (res.code === 200) {
            const { each_amount, total_amount } = res.data;
            if (each_amount) {
              res.data.each_amount = each_amount / 100;
            }
            if (total_amount) {
              res.data.total_amount = total_amount / 100;
            }
            this.ruleForm = res.data;
          }
        });
      }
    },
    mounted() {
      this.redPacketId && this.getRedPacketInfo();
    }
  };
</script>
<style lang="less" scoped>
  .text-mute {
    line-height: 40px;
    color: #8c8c8c;
    font-size: 14px;
  }
  .text-notice {
    line-height: 22px;
    color: #595959;
    font-size: 14px;
  }
</style>
